import React from 'react';

const DiscussionPlaceholder = () => (
  <div className="discussion-topic" style={{ backgroundColor: '#ddd' }}>
    <div className="top-row">
      <div
        className="teacher-info animated-background"
        style={{ width: '44px', height: '44px', borderRadius: '50%' }}
      />
      <span>
        <div className="teacher-info animated-background" style={{ width: '30%', height: '15px' }} />
        <div className="dates-content">
          <div className="animated-background" style={{ width: '65%', height: '15px' }} />
        </div>
      </span>
    </div>
    <div className="discussion-body">
      <div className="discussion-title animated-background" style={{ width: '50%', height: '20px' }} />
      <div
        className="discussion-description animated-background"
        style={{ width: '100%', height: '15px', marginTop: '7px' }}
      />
      <div
        className="discussion-description animated-background"
        style={{ width: '100%', height: '15px', marginTop: '7px' }}
      />
      <div
        className="discussion-description animated-background"
        style={{ width: '70%', height: '15px', marginTop: '7px' }}
      />
    </div>
    <div className="new-post">
      <div className="new-post-input-text">
        <div className="animated-background" style={{ width: '44px', height: '44px', borderRadius: '50%' }} />
        <div className="animated-background" style={{ width: '100%', height: '40px', marginLeft: '20px' }} />
      </div>
      <div className="submit-button">
        <div className="animated-background" style={{ width: '68px', height: '40px', marginLeft: '20px' }} />
      </div>
    </div>
  </div>
);

export default DiscussionPlaceholder;
